import { useState } from "react";

/**
 * @return {[handleAnnotationActionsRequest: Function, isActionPending: boolean]}
 * the handleAnnotationActionsRequest function and the action pending state
 */
const useHandleAnnotationActionsRequest = () => {
  const [isActionPending, setIsActionPending] = useState(false);

  /**
   * @param {Function} actionRequest Annotation action request
   * @param {Object} payload Annotation action payload
   * @param {Function} handleActionSuccess Triggered if actionRequest is successful
   * @returns '{data, error}' object returned by actionRequest
   */
  const handleAnnotationActionsRequest = async (
    actionRequest,
    payload,
    handleActionSuccess,
  ) => {
    try {
      setIsActionPending(true);
      const { data, error } = await actionRequest(payload);
      await handleActionSuccess();
      setIsActionPending(false);
      return { data, error };
    } catch (_error) {
      // TODO: Handle error
      setIsActionPending(false);
    }
  };

  return [handleAnnotationActionsRequest, isActionPending];
};

export default useHandleAnnotationActionsRequest;
